import { IConsentForm } from "@/api/dtos";
import { useCrfFormSubmitAndReturn } from "@ngt/opms";

const useEConsentFormSubmitAndReturn =  <TData extends IConsentForm = IConsentForm>() => useCrfFormSubmitAndReturn<TData>();

export default useEConsentFormSubmitAndReturn;